import React from "react";
import styles from "../../css/Docs/DocsHome.module.css";
import HeaderWithoutProducts from "../Common/HeaderWithProducts";
import { Link } from "react-router-dom";
import Footer from "../Common/Footer";
// import MainLayout from "./MainLayout";
import headerImg from "../../images/landingpage/header.svg";
import Sidebar from "../Sidebar/Sidebar";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useState } from "react";
import MainLayout from "./MainLayout";
import Introduction from "./Introduction";

const DocsHome = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <div className={styles.container}>
      <HeaderWithoutProducts />
      <div className={styles.header}>
        <div className={styles.leftBox}>
          <h1>
            Welcome to <br />
            <span style={{ color: "#1904ff" }}> EQLFIN Developer </span> <br />
            Documentation
          </h1>
          <p>
            Discover comprehensive resources, including guides and API
            references, to swiftly kickstart your utilization of our products
            and APIs.
          </p>
        </div>
        <div className={styles.rightBox}>
          <img src={headerImg} alt="dev" className={styles.headerImg} />
        </div>
      </div>

      <div
        style={{
          width: "100%",
          backgroundColor: "#cbf0ff",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div className={styles.useCaseContainer}>
          <h2>Use Cases</h2>
          <div className={styles.useCaseCardContainer}>
            <div className={styles.useCaseCard}>
              <h4>Other Income</h4>
              <hr />
              <div>Help your clients earn additional income</div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <div className={styles.mainLayoutWrapper}>
        <MainLayout>{children}</MainLayout>
      </div>
      <Footer />
    </div>
  );
};

export default DocsHome;
